<form [formGroup]="form" class="m-form" novalidate>
    <ng-select class="select2" [items]="data$ | async"
        bindLabel="name" bindValue="id" formControlName="id" (change)="onSelect($event)"
        [placeholder]="'classificacao.etapa' | translate" [notFoundText]="'geral.not-found' | translate">
    </ng-select>
</form>